module.exports = __webpack_public_path__ + "img/fifa-21.df23ded3.png";